// Onboarding Loader component - displayed while data is fetching

import { Box, CircularProgress } from '@mui/material';

export const OnboardingLoader = () => (
  <Box
    sx={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: '100vh',
      width: '100%',
    }}
  >
    <CircularProgress color="info" />
  </Box>
);
